/**
 * CTS flow
 * - Reveal cards with a staggered fade-up as they scroll into view.
 *   Cards stay fully visible without JS, with reduced motion, or without IntersectionObserver.
 * - Length / Pieces / Weight filters on the variant list (sections/main-cts-variants.liquid).
 */
(function() {
    function initReveal(root) {
        var cards = (root || document).querySelectorAll('[data-cts-reveal]:not(.is-visible)');
        if (!cards.length) return;

        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion || !('IntersectionObserver' in window)) {
            cards.forEach(function(card) { card.classList.add('is-visible'); });
            return;
        }

        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (!entry.isIntersecting) return;
                var card = entry.target;
                card.classList.add('is-visible');
                observer.unobserve(card);

                // Drop the reveal classes once done so the stagger delay doesn't slow hover effects
                var delay = (parseInt(card.style.getPropertyValue('--i'), 10) || 0) * 80;
                setTimeout(function() { card.classList.remove('is-pending'); }, 700 + delay);
            });
        }, { rootMargin: '0px 0px -40px 0px', threshold: 0.1 });

        cards.forEach(function(card) {
            card.classList.add('is-pending');
            observer.observe(card);
        });
    }

    function initFilters(root) {
        (root || document).querySelectorAll('[data-cts-filters]').forEach(function(bar) {
            if (bar.dataset.ctsReady) return;
            bar.dataset.ctsReady = 'true';

            var body = bar.closest('.cts-flow__body');
            var cards = Array.prototype.slice.call(body.querySelectorAll('.cts-variant-card'));
            var selects = Array.prototype.slice.call(bar.querySelectorAll('[data-cts-filter]'));
            var clearBtn = bar.querySelector('[data-cts-filter-clear]');
            var emptyMsg = body.querySelector('[data-cts-filter-empty]');
            var countEl = body.querySelector('[data-cts-count]');

            // Card values are '||'-joined so list metafields can match several values
            function valuesOf(card, key) {
                var raw = card.getAttribute('data-f-' + key) || '';
                return raw ? raw.split('||') : [];
            }

            function matches(card, active, skipKey) {
                return Object.keys(active).every(function(key) {
                    return key === skipKey || valuesOf(card, key).indexOf(active[key]) !== -1;
                });
            }

            function currentFilters() {
                var active = {};
                selects.forEach(function(select) {
                    if (select.value) active[select.dataset.ctsFilter] = select.value;
                });
                return active;
            }

            function apply(updateUrl) {
                var active = currentFilters();
                var visible = 0;

                cards.forEach(function(card) {
                    var show = matches(card, active);
                    card.hidden = !show;
                    if (show) visible++;
                });

                // Disable choices that would give no results with the other filters as they are
                selects.forEach(function(select) {
                    var key = select.dataset.ctsFilter;
                    Array.prototype.forEach.call(select.options, function(option) {
                        if (!option.value) return;
                        var possible = cards.some(function(card) {
                            return matches(card, active, key) && valuesOf(card, key).indexOf(option.value) !== -1;
                        });
                        option.disabled = !possible && option.value !== select.value;
                    });
                    select.classList.toggle('is-active', !!select.value);
                });

                if (countEl) countEl.textContent = visible;
                if (emptyMsg) emptyMsg.hidden = visible > 0;
                if (clearBtn) clearBtn.hidden = Object.keys(active).length === 0;

                // Keep filters in the URL so the product page's "Back" link returns to the same view
                if (updateUrl && window.history.replaceState) {
                    var url = new URL(window.location.href);
                    selects.forEach(function(select) {
                        var key = select.dataset.ctsFilter;
                        if (select.value) url.searchParams.set(key, select.value);
                        else url.searchParams.delete(key);
                    });
                    window.history.replaceState(window.history.state, '', url.toString());
                }
            }

            // Restore filters from the URL
            var params = new URLSearchParams(window.location.search);
            selects.forEach(function(select) {
                var wanted = params.get(select.dataset.ctsFilter);
                if (!wanted) return;
                var exists = Array.prototype.some.call(select.options, function(option) { return option.value === wanted; });
                if (exists) select.value = wanted;
            });

            selects.forEach(function(select) {
                select.addEventListener('change', function() { apply(true); });
            });

            if (clearBtn) {
                clearBtn.addEventListener('click', function() {
                    selects.forEach(function(select) { select.value = ''; });
                    apply(true);
                });
            }

            apply(false);
        });
    }

    function init(root) {
        initFilters(root);
        initReveal(root);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() { init(); });
    } else {
        init();
    }

    document.addEventListener('shopify:section:load', function(event) { init(event.target); });
})();
